import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Button, CircularProgress } from '@mui/material';
import Filters from 'src/components/Items/Filters';
import VanCard from 'src/pages/Van/components/item';
import NoResult from 'src/components/Items/NoResult';
import LocationsFilter from 'src/components/Items/Filters/General/Locations';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import showFilterErrors from 'src/common/utils/showFilterErrors';
import { validateFilter } from 'src/common/utils/validateFilter';
import './styles.scss';
import './media.scss';

const HostPageVans: FC = () => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { setupFilters, setStartDateFilter, setEndDateFilter, errorFilter, setCheckFilter } =
    useActions();
  const container = document.getElementsByClassName('host-vans')[0];
  const host = useTypedSelector(state => state.host.host);
  const { vanList, checkFilter, filters, errors, isFilterValidate, isLoading } = useTypedSelector(
    state => state.van
  );

  useEffect(() => {
    validateFilter(filters, errorFilter);
  }, [filters]);

  const handleSubmit = () => {
    if (isFilterValidate) {
      setupFilters({ ...filters, tags: [id!.toUpperCase()] });
    } else {
      setCheckFilter();
      showFilterErrors(enqueueSnackbar, errors);
    }
  };

  return (
    <div className='host-vans'>
      <p className='host-vans__title'>{host!.first_name}'s Vehicles</p>
      <div className='host-vans__search'>
        <LocationsFilter type='sec' />
        <Filters.Times
          className={'singleVan__availability__formContainer__times'}
          check={checkFilter}
          startDate={filters.start_date}
          endDate={filters.end_date}
          handleStartDate={setStartDateFilter}
          handleEndDate={setEndDateFilter}
        />
        <Button onClick={handleSubmit} variant='contained' className='host-vans__search__button'>
          {isLoading.all ? <CircularProgress size={16} /> : 'GET VANS'}
        </Button>
      </div>
      {Object.keys(vanList).length ? (
        <div className='host-vans__list'>
          <>
            {vanList[Object.keys(vanList)[0]].length ? (
              Object.keys(vanList).map(location =>
                vanList[location].map(van => (
                  <VanCard
                    van={van}
                    key={van.id}
                    errors={errors}
                    isFilterValidate={isFilterValidate}
                    container={container}
                  />
                ))
              )
            ) : (
              <NoResult margin='30px auto' />
            )}
          </>
        </div>
      ) : (
        <div className='host-vans__loading'>
          <CircularProgress size={100} />
        </div>
      )}
    </div>
  );
};
export default HostPageVans;
